import { useTranslation } from "react-i18next";

/**
 * Error state component for media attachments
 * Displays an error message with a retry button
 */
interface MediaAttachmentErrorProps {
  onRetry: () => void;
}

export default function MediaAttachmentError({
  onRetry,
}: MediaAttachmentErrorProps) {
  const { t } = useTranslation();

  return (
    <div className="flex size-full items-center justify-center p-4">
      <div className="text-center text-destructive">
        <p>{t("error_loading_media", "Error loading media attachments")}</p>
        <button
          className="rounded mt-2 bg-primary px-2 py-1 text-sm text-primary-foreground"
          onClick={onRetry}
        >
          {t("retry", "Retry")}
        </button>
      </div>
    </div>
  );
}
